import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import partner3 from "../../assets/img/ep.png";
import partner1 from "../../assets/img/ep1.png";
import partner2 from "../../assets/img/ep2.png";
import Footer from "../../components/Footer";
import Navbar from "../../components/NavBar";
import config from "../../configs";
import apiroutes from "../../services/apiroutes";
import { request } from "../../services/apiservice";
import { setAmbassadorAuth, setPartnerAuth } from "../../services/auth";
import IndividualPartner from "./IndividualPartner/individual";
// import "./enterprise.css";
import Swal from "sweetalert2";
import { decrypt, encrypt } from "../../components/util";
import SwiperCore, {
  Autoplay,
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/swiper-bundle.css";
import "swiper/swiper.min.css";

SwiperCore.use([Autoplay, Navigation, Pagination, Scrollbar, A11y]);


const UpgradePartner = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [individual, setIndividual] = useState(true);
 

  return (
    <div>
      <Navbar />

      <section className="enterprise">
        <div className="container">
          <div className="row">
          
            <div className="col-md-12">
              <div className="slider-holder upgrade-slider">
              <Swiper
                      slidesPerView={3}
                      spaceBetween={30}
                      navigation
                      autoplay={{
                        delay: 2000,
                        disableOnInteraction: false,
                      }}
                      rewind={true}
                      pagination={{ clickable: true }}
                      // scrollbar={{ draggable: true }}
                      // onSwiper={(swiper) => console.log(swiper)}
                      // onSlideChange={() => console.log("slide change")}
                      className="mySwiper"
                    >
                  <SwiperSlide>
                    <div className="slide-partner">
                      <img src={partner1} alt="" loading="lazy" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="slide-partner">
                      <img src={partner2} alt="" loading="lazy" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="slide-partner">
                      <img src={partner3} alt="" loading="lazy" />
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="slide-partner">
                      <img src={partner2} alt="" loading="lazy" />
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
      <IndividualPartner/>

      <Footer />
    </div>
  );
};

export default UpgradePartner;
